<template>
    <b-tab @click="showAssinatura = false" active>
        <template #title>
            <i class="mdi mdi-account-details-outline"></i>
            Informações
        </template>
        <form @submit.prevent="$emit('add')" ref="addItem">
            <div class="row">
                <form-input
                    grid="9"
                    v-model="item.nome"
                    :required="true"
                    label="Nome"
                />
                <form-input
                    grid="3"
                    v-model="item.cpf"
                    v-mask="'###.###.###-##'"
                    label="CPF"
                />
                <form-input
                    grid="3"
                    label="Data de Nascimento"
                    v-model="item.data_nascimento"
                    placeholder="00/00/0000"
                    type="date"
                    :required="true"
                />
                <form-input
                    grid="3"
                    v-model="item.telefone"
                    v-mask="'(##) #####-####'"
                    placeholder="(00) 00000-0000"
                    label="Telefone"
                />
                <form-input
                    grid="3"
                    v-model="item.whatsapp"
                    v-mask="'(##) #####-####'"
                    placeholder="(00) 00000-0000"
                    label="Whatsapp"
                />
                <form-input grid="6" v-model="item.profissao" label="Cargo" :required="true" />
                <form-input grid="6" v-model="item.conselho_profissional" label="Conselho Profissional" />
                <form-input grid="6" v-model="item.numero_registro" label="Número de Registro" />
                <form-textarea-editor
                    v-if="item.observacoes"
                    v-model="item.observacoes"
                    label="Observação"
                    grid="12"
                />
                <form-toggle
                    class="d-flex justify-content-end"
                    mt="0"
                    v-model="item.send_mail"
                    label="Enviar notificações por e-mail"
                    :ajuda="item.send_mail == 1 ? 'Todas as notificações serão enviadas por e-mail.' : 'O envio por e-mail está desabilitado. Apenas as notificações de PRAZOS continuaram sendo enviadas.'"
                />
            </div>
            <div class="float-right mt-3" v-if="showAssinatura == false">
                <router-link class="btn btn-default" to="/dashboard/tecnicos">
                    <i class="mdi mdi-arrow-left" />
                </router-link>
                <button
                    class="btn btn-success btn-submit"
                    data-style="zoom-in"
                    type="submit"
                >
                    <i class="mdi mdi-content-save" />
                    {{ $t("Salvar") }}
                </button>
            </div>
        </form>
    </b-tab>
</template>
<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => {},
        },
        status: {
            type: Object,
            default: () => {},
        },
        passwordInput: {
            type: String,
            default: null,
        },
        showAssinatura: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return { progressCompleted: 0 };
    },
};
</script>
